import React, {useState, useEffect } from "react";

import LoadingSpinner from "../../components/modalComponents/loadingSpinner/LoadingSpinner";
import Pagination from "../../components/posts/Pagination";
import Posts from "../../components/posts/Posts";
import "./Blog.scss";



export default function Blog() {

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage, ] = useState(5);





//Change the page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    useEffect(() => {

        async function fetchPosts() {
            setLoading(true);

            fetch('https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@sahanamarsha')
                .then((res) => res.json())
                .then((data) => {
                    //Filter the array
                    const res = data.items ;
                    const posts1= res.filter(item => item.categories.length > 0);//This is an array with the content. No feed, no info about author etc..
                    console.log(posts1);
                    setPosts(posts1); // That's the main trick* !
                })
                .catch((err)=>{


                    }
                );
            setLoading(false);

        }
        fetchPosts();

    }, []);

//get current posts
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);
    posts.forEach((postItem) => {console.log(postItem)});
// currentPosts.map((postItem)=> console.log(postItem));
    return (
        <React.Fragment>
            {loading && (
                <div className="center blog-container">
                    <LoadingSpinner asOverlay/>
                </div>
            )}
            <div className="blog-container text-center p-4">
                <div className="mb-4 blog-header">MY BLOG</div>
                <Posts posts={currentPosts} loading={loading} />
                <Pagination postsPerPage={postsPerPage} totalPosts={posts.length} paginate={paginate}/>
            </div>
        </React.Fragment>
    );

}






